import type { DeepPartial, MessageCatalog } from './types';

const tg: DeepPartial<MessageCatalog> = {
  nav: {
    home: 'FalaRus',
    partner: 'Суҳбат',
    teachers: 'Муаллимон',
    stats: 'Омор',
    profile: 'Профил',
  },
  profile: {
    tapPhoto: 'Барои интихоби акс пахш кунед',
    premiumDaysLeft: 'Premium · {{days}} рӯз монд',
    groups: {
      personal: 'Шахсӣ',
      settings: 'Танзимот',
      help: 'Кӯмак',
    },
    rows: {
      profile: 'Профил',
      certificates: 'Сертификатҳо',
      invite: 'Дӯстонро даъват кунед',
      textSize: 'Андозаи матн',
      notifications: 'Огоҳиҳо',
      darkMode: 'Реҷаи торик',
      language: 'Забон',
      sound: 'Садо ва вибратсия',
      help: 'Кӯмак',
      pricing: 'Тарифҳо',
      paymentHistory: 'Таърихи пардохт',
      logout: 'Баромад',
    },
    firstName: 'Ном',
    lastName: 'Насаб',
    save: 'Захира',
    cancel: 'Бекор',
    nameUpdated: 'Ном навсозӣ шуд',
    avatarUpdated: 'Акси профил навсозӣ шуд',
    avatarUploadFailed: 'Бор кардани акс муваффақ нашуд',
    nameRequired: 'Ном ва насаб зарур аст',
  },
  common: {
    user: 'Корбар',
    save: 'Захира',
    cancel: 'Бекор',
  },
  language: {
    selectTitle: 'Забонро интихоб кунед',
    selectSubtitle: 'Забони интерфейс',
  },
  auth: {
    benefits: {
    },
    register: 'Бақайдгирӣ',
    logIn: 'Вуруд',
    logInTitle: 'Вуруд',
    createAccountTitle: 'Бақайдгирӣ',
    phone: 'Телефон',
    email: 'Email',
    password: 'Рамз',
    createPassword: 'Рамз эҷод кунед',
    rewritePassword: 'Рамзро такрор кунед',
    name: 'Ном',
    surname: 'Насаб',
    emailHint: 'username@gmail.com',
    forgotPassword: 'Рамзро фаромӯш кардед?',
    or: 'Ё',
    continueWithGoogle: 'Бо Google идома диҳед',
    noAccount: 'Ҳисоб надоред? ',
    signUp: 'Бақайдгирӣ',
    haveAccount: 'Ҳисоб доред? ',
    emailRequired: 'Email зарур аст',
    emailInvalid: 'Email нодуруст аст',
    phoneInvalid: 'Рақами телефон нодуруст аст',
    passwordRequired: 'Рамз зарур аст',
    passwordMinLength: 'Рамз ҳадди ақал 6 аломат бошад',
    passwordsMismatch: 'Рамзҳо мувофиқат намекунанд',
    nameRequired: 'Ном зарур аст',
    surnameRequired: 'Насаб зарур аст',
    termsPrefix: 'Бо кушодани ҳисоб ман ',
    termsOfUse: 'Шартҳои истифода',
    termsAnd: ' ва ',
    privacyPolicy: 'Сиёсати махфият',
    termsSuffix: '-ро қабул мекунам.',
    resetTitle: 'Барқарор кардани рамз',
    resetSubtitle: 'Рамзи нав ба email мефиристем',
    resetSendPassword: 'Фиристодани рамзи нав',
    resetSuccessTitle: 'Email фиристода шуд',
    resetSuccessSubtitle: 'Агар ҳисоб мавҷуд бошад, рамзи нав ба email фиристода шуд',
    networkError: 'Пайвасти интернет нест. Лутфан боз кӯшиш кунед.',
    genericError: 'Хатогӣ рух дод',
  },
};

export default tg;
